/**
 * Created by alvinoktavianus (https://github.com/alvinoktavianus)
 * on 27/03/18
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Modal } from 'react-bootstrap';
import { setOpenRegistrationOutletModal } from 'actions/setting/paymentMethod';
import styles from './styles.css';

class RegistrationOutletModal extends Component {
  render() {
    const { openRegistrationOutletModal, handleClose, outlets } = this.props;
    return (
      <Modal show={openRegistrationOutletModal} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Outlet Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={styles['table-wrapper']}>
            <div>
              <table
                className={`table ${styles['table-no-margin']} ${
                  styles['table-header']
                }`}
              >
                <thead>
                  <tr>
                    <th className={styles['table-outlet-wrapper']}>
                      Outlet Name
                    </th>
                    <th className={styles['table-address-wrapper']}>Address</th>
                  </tr>
                </thead>
              </table>
            </div>
            <div className={styles['table-body-wrapper']}>
              <table className={`table ${styles['table-no-margin']}`}>
                <tbody>
                  {outlets.map(outlet => {
                    return (
                      <tr key={outlet.id}>
                        <td className={styles['table-outlet-wrapper']}>
                          <div className={styles['text-wrapper']}>
                            <div className={styles['text-elipsis']}>
                              {outlet.name}
                            </div>
                          </div>
                        </td>
                        <td className={styles['table-address-wrapper']}>
                          <div className={styles['text-address-wrapper']}>
                            <div className={styles['text-elipsis']}>
                              {outlet.full_address}
                            </div>
                          </div>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => {
              this.props.dispatch(setOpenRegistrationOutletModal(false));
            }}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  const { openRegistrationOutletModal, outlets } = state.setting.paymentMethod;
  return {
    openRegistrationOutletModal,
    outlets,
  };
}

export default connect(mapStateToProps)(RegistrationOutletModal);
